import {
  ref,
  uploadBytes,
  getDownloadURL,
  listAll,
  deleteObject,
} from "firebase/storage";
import { storage } from "./firebase"; // Importa la instancia correcta de Firebase Storage

// Sube varias imágenes y retorna sus URLs
export const saveMultipleImages = async (files, id) => {
  try {
    const urls = await Promise.all(
      files.map(async (file, index) => {
        // Crear una referencia única para cada archivo
        const storageRef = ref(storage, `/${id}/image_${index + 1}.jpeg`);

        // Subir el archivo
        await uploadBytes(storageRef, file);

        // Obtener la URL de descarga
        const url = await getDownloadURL(storageRef);
        return url;
      })
    );
    return urls; // Array de URLs
  } catch (error) {
    console.error("Error al subir las imágenes:", error);
    throw error;
  }
};

// Función para eliminar una imagen del storage
export const deleteImageFromStorage = async (imageUrl) => {
  try {
    // Obtener la referencia al archivo en el storage
    const storageRef = ref(storage, imageUrl);

    // Eliminar el archivo
    await deleteObject(storageRef);

    //console.log("Imagen eliminada con éxito del storage");
  } catch (error) {
    console.error("Error al eliminar la imagen del storage:", error);
    throw error;
  }
};

// Función para obtener las URLs de las imágenes basadas en un ID
export const getImagesById = async (id) => {
  try {
    // Referencia al directorio donde se encuentran las imágenes (basado en el ID)
    const folderRef = ref(storage, `/${id}`);

    // Obtener la lista de archivos en ese directorio
    const result = await listAll(folderRef);

    // Obtener las URLs de las imágenes
    const urls = await Promise.all(
      result.items.map(async (itemRef) => {
        const url = await getDownloadURL(itemRef);
        return url;
      })
    );

    return urls; // Array de URLs
  } catch (error) {
    console.error("Error al obtener las imágenes:", error);
    throw error;
  }
};
